import { format, parse } from 'date-fns';
import { ru } from 'date-fns/locale';

export default (datetime: string): string => format(parse(datetime, 'yyyy-MM-dd HH:mm:ss', new Date()), 'd MMMM yyyy г. HH:mm', { locale: ru });